/**
 * Retourne la valeur d'un cookie par son nom.
 *
 * @param {String} name Nom du cookie.
 * @returns {String|null} Valeur du cookie. Null si le cookie n'est pas trouvé.
 */
function ff_get_cookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}


// Exportation
export {
  ff_get_cookie // eslint-disable-line import/prefer-default-export
};
